// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PropList-item {
    display: flex;
    border: 1px dashed #999;
    margin: 5px 0;
    padding: 5px;
}

.PropListItem.IsActive {
    text-decoration: line-through;
    background: #80eec5;
}

.PropListItem-text {
    flex-grow: 1;
    /* Removes outline when using contentEditable */
    outline: none;
    margin-left: 10px;
    min-height: 20px;
    overflow: hidden;
    word-break: break-word;
}

.PropListItem-item.focused {
    border-color: #2992e9;
    border-style: solid;
}

.PropListItem-item.invalid {
    border-color: #da3b71;
    border-style: solid;  
}
`, "",{"version":3,"sources":["webpack://./components/AdminItems/CustomComponents/PropListItem.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,+CAA+C;IAC/C,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB","sourcesContent":[".PropList-item {\n    display: flex;\n    border: 1px dashed #999;\n    margin: 5px 0;\n    padding: 5px;\n}\n\n.PropListItem.IsActive {\n    text-decoration: line-through;\n    background: #80eec5;\n}\n\n.PropListItem-text {\n    flex-grow: 1;\n    /* Removes outline when using contentEditable */\n    outline: none;\n    margin-left: 10px;\n    min-height: 20px;\n    overflow: hidden;\n    word-break: break-word;\n}\n\n.PropListItem-item.focused {\n    border-color: #2992e9;\n    border-style: solid;\n}\n\n.PropListItem-item.invalid {\n    border-color: #da3b71;\n    border-style: solid;  \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
